import { VIEW_MODES } from '@aytm/app/stats/page/question-views/mn/lib/viewOptions'

export const applyUnitTemplate = (value, viewMode, priceTemplate) => {
  if (viewMode === VIEW_MODES.P_AMOUNT && priceTemplate) {
    value.unitTemplate = priceTemplate.replace(/{{price}}/gi, '{{unit}}')
  }
}
